<template>
  <div class="services">
    <div class="services_tabs" v-if="isChain">
      <el-tabs
        class="service-el-tabs"
        v-model="$activeService"
        @tab-click="onTabClick">
        <el-tab-pane
          v-for="(item, index) in tabs"
          :key="item.id"
          :label="item.title"
          :name="`${index}`">
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="services_item" v-if="JSON.stringify(serviceData) !== '{}'">
      <div class="services_item_left">
        <div class="user">
          <order-title title="供方基本信息" />
          <div class="user_item text_size_14">
            <p class="user_item_label">供方：</p>
            <div class="user_item_value">
              <p class="org">
                {{seller.organizationName}}
              </p>
            </div>
          </div>
          <div class="user_item text_size_14">
            <p class="user_item_label">联系人：</p>
            <p class="user_item_value">{{seller.username}}</p>
          </div>
          <div class="user_item text_size_14">
            <p class="user_item_label">联系方式：</p>
            <p class="user_item_value">{{seller.mobile}}</p>
          </div>
          <div class="user_item text_size_14">
            <p class="user_item_label">订单类型：</p>
            <p class="user_item_value">
              {{{service_chain: '服务链订单', service: '服务订单'}[order.orderType]}}
            </p>
          </div>
          <div class="user_item text_size_14">
            <p class="user_item_label">服务类型：</p>
            <p class="user_item_value">{{service.serviceTypeName}}</p>
          </div>
          <div class="user_item text_size_14">
            <p class="user_item_label">服务价格（元）：</p>
            <p class="user_item_value tw-font-bold" style="color:#FF4343;">{{service.fee}}</p>
          </div>
        </div>
        <div class="user">
          <order-title title="需方基本信息" />
          <div class="user_item tw-text-14px">
            <p class="user_item_label">联系人：</p>
            <p class="user_item_value">{{buyer.username}}</p>
          </div>
          <div class="user_item tw-text-14px">
            <p class="user_item_label">联系方式：</p>
            <p class="user_item_value">{{buyer.mobile}}</p>
          </div>
        </div>
      </div>
      <div class="services_item_right">
        <div class="process">
          <order-title title="服务流程信息" />
          <div class="process_main">
            <el-steps
              direction="vertical"
              :active="activeProgress"
              finish-status="success">
              <el-step
                v-for="(item, index) in progress"
                :key="item.id">
                <template slot="title">
                  <div class="process_title">
                    <p class="process_title_name">
                      {{item.name}}
                    </p>
                    <p class="process_title_line"></p>
                    <button
                      class="process_title_btn"
                      @click="onCheck(index)">
                      查看详情
                    </button>
                  </div>
                </template>
              </el-step>
            </el-steps>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="流程详情"
      width="600px"
      :visible.sync="dialogVisible"
      :show-close="false">
      <custom-form
        v-if="checkIndex > -1"
        ref="customForm"
        mode="static"
        :formModel="fieldList"
        :formData="formData">
        <custom-form-item
          v-for="item in fieldList"
          :key="item.column"
          :item="item"
          :value.sync="formData[item.column]">
        </custom-form-item>
      </custom-form>

      <div slot="footer">
        <el-button
          size="small"
          @click="onCancel">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api'

import orderTitle from './order-title'
import customForm from '@/components/custom-form/index'
import customFormItem from '@/components/custom-form/custom-form-item'

export default {
  components: {
    orderTitle,
    customForm,
    customFormItem
  },
  props: {
    order: Object,
    activeService: String // 标记当前选择的服务
  },
  data () {
    return {
      serviceData: {}, // 当前选择的服务相关数据
      dialogVisible: false,
      checkIndex: -1,
      fieldList: [],
      formData: {}
    }
  },
  computed: {
    $activeService: {
      get () {
        return this.activeService
      },
      set (val) {
        this.$emit('update:activeService', val)
      }
    },
    // 是否是服务链订单
    isChain () {
      return this.order.orderType === 'service_chain' || false
    },
    // tab栏
    tabs () {
      return this.order.tabs
    },
    // 当前服务的买家
    buyer () {
      return this.serviceData.buyer
    },
    // 当前服务的卖家
    seller () {
      return this.serviceData.seller
    },
    // 当前服务
    service () {
      return this.serviceData.service
    },
    serviceId () {
      return this.order.tabs[this.$activeService].id
    },
    // 服务流程
    progress () {
      return this.serviceData.progress
    },
    activeProgress () {
      let activeIndex = 0
      for (let index = 0; index < this.progress.length; index++) {
        const element = this.progress[index]
        if (element.status === 0) {
          activeIndex = index
          break
        }
        if (index === this.progress.length - 1) {
          activeIndex = index + 1
        }
      }
      return activeIndex
    }
  },
  mounted () {
    this.getServiceData()
  },
  methods: {
    onTabClick () {
      this.$nextTick(() => {
        this.getServiceData()
      })
    },
    getServiceData (serviceId = this.serviceId) {
      api.getOrderServiceDetail(this.order.id, {
        serviceId
      }).then(res => {
        if (res.data.code === 0) {
          this.serviceData = {
            ...res.data.data
          }
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('请求出错')
      })
    },
    onCheck (index) {
      this.fieldList = this.$clone(this.progress[index].fields)
      this.formData = this.$clone(this.progress[index].data)

      this.checkIndex = index
      this.dialogVisible = true
    },
    onCancel () {
      this.checkIndex = -1
      this.fieldList = []
      this.formData = {}
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.services {
  width: 1200px;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  border-radius: 6px;
  overflow: hidden;
  &_tabs {
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
  }
  &_item {
    position: relative;
    padding: 20px 0 30px 0;
    display: flex;
    &_left {
      width: 362px;
      padding: 0 30px;
    }
    &_right {
      flex: 1;
      padding: 0 120px 0 30px;
    }
    &::before {
      content: "";
      position: absolute;
      top: 20px;
      bottom: 30px;
      left: 362px;
      width: 1px;
      border-left: 1px solid #DCDFE6;
    }
  }
}
.user {
  &_item {
    display: flex;
    padding: 5px 0;
    min-height: 30px;
    margin-bottom: 10px;
    &_label {
      width: 130px;
      line-height: 20px;
      padding-left: 10px;
      color: #909399;
    }
    &_value {
      flex: 1;
      line-height: 20px;
      color: #303133;
      .org {
        & > i {
          margin: 2px 0 2px 10px;
          color: #3473E6;
        }
      }
    }
  }
}
.process {
  &_title {
    display: flex;
    align-items: center;
    margin-bottom: 60px;
    &_name {
      line-height: 20px;
      font-weight: bold;
    }
    &_line {
      flex: 1;
      height: 1px;
      margin: 0 20px;
      border-top: 1px dashed #DCDFE6;
    }
    &_btn {
      cursor: pointer;
      color: #909399;
      border-color: transparent;
      background: transparent;
      &:hover, &:focus {
        opacity: 0.8;
      }
    }
  }
}
</style>
